import "./restaurant-code.styles.scss";
const RestaurantCode = ({ closeFunction }) => {
  const hotelID = localStorage.getItem("hotelID");
  return (
    <div className="restaurant-code-container" onClick={closeFunction}>
      <div className="restaurant-code-box">
        <span className="restaurant-code">
          <span className="tag">Unique ID : </span>
          {hotelID}
        </span>
        <span className="restaurant-instruction">
          Use Host or Kitchen Account option from the Home page.
        </span>
      </div>
    </div>
  );
};
export default RestaurantCode;
